import { Button, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import ConfirmMobileNumberModalPropTypes from './ConfirmMobileNumberModal.component.props';
import confirmMobileNumberModalStyles from './ConfirmMobileNumberModal.component.styles';

/**
 * ConfirmMobileNumberModal
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const ConfirmMobileNumberModal = ({ classes, open, onNo, onYes, mobileNumber }) => {
  return (
    <Modal
      preventFullScreen
      minWidth={400}
      paperClasses={classes.paperClasses}
      hideCloseButton
      content={
        <Grid container>
          {!mobileNumber ? (
            <Grid item xs={12} className={classes.notificationsPanelContainer}>
              <Spinner />
            </Grid>
          ) : (
            <Grid item xs={12} className={classes.notificationsPanelContainer}>
              <Typography variant="body2">Your mobile number is currently set to:</Typography>
              <Typography variant="h6" className={classes.phoneNumber}>
                {mobileNumber}
              </Typography>
              <Typography variant="body2">A correct Australian number is required to receive notifications by SMS. Is this number correct?</Typography>
            </Grid>
          )}
        </Grid>
      }
      maxWidth="sm"
      open={open}
      title={
        <Grid container>
          <Grid item xs={12}>
            Confirm Mobile Number
          </Grid>
        </Grid>
      }
      footer={
        mobileNumber ? (
          <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
            <Grid item>
              <Button className={classes.button} color="primary" onClick={onYes} variant="contained">
                Yes
              </Button>
            </Grid>
            <Grid item>
              <Button className={classes.button} color="primary" onClick={onNo} variant="contained">
                No
              </Button>
            </Grid>
          </Grid>
        ) : null
      }
    />
  );
};

// ConfirmMobileNumberModal.propTypes = ConfirmMobileNumberModalPropTypes;

export default compose(
  withStyles(themeCreateInjectableStyles(confirmMobileNumberModalStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(ConfirmMobileNumberModal);
